var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/EstimationTree/ItemRenderer/FolderRenderer.tsx";
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { getExplorerFolderIcon } from "../../../utils/getExplorerFolderIcon";
import { ItemTooltip } from "../../ItemTooltip";
import { useExplorerItemStyles } from "../../../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FolderRenderer = function FolderRenderer(_ref) {
  var node = _ref.item.payload,
      selected = _ref.selected,
      onSelect = _ref.onSelect;
  var itemListStyles = useExplorerItemStyles();
  return /*#__PURE__*/_jsxs(ListItem, {
    dense: true,
    button: true,
    onClick: function onClick() {
      return onSelect();
    },
    selected: selected,
    classes: itemListStyles,
    children: [/*#__PURE__*/_jsx(ListItemIcon, {
      children: getExplorerFolderIcon(!node.total)
    }), /*#__PURE__*/_jsx(ListItemText, {
      children: /*#__PURE__*/_jsx(ItemTooltip, {
        title: node.title,
        children: /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          variant: "body2",
          children: node.title
        })
      })
    })]
  });
};